import * as yup from "yup";

export const NPI_VALIDATION = yup.object().shape({
  npi: yup
    .string()
    .matches(/^[0-9]+$/, "NPI number must be digits")
    .min(
      10,
      "You can only search by an exact NPI number, which is 10 digits long."
    )
    .max(
      10,
      "You can only search by an exact NPI number, which is 10 digits long."
    )
    .required("Enter NPI number"),
});
